import React, {useReact} from 'react';
import { Row, Col } from 'react-bootstrap';

const View = (props) => {
    return (
        <div className="card">
            <div>
                <b>{props.title}</b>
            </div>
            <Row>
                <Col>
                    {props.name}
                </Col>
                <Col>
                    {props.phone}
                </Col>
            </Row>
            <div>
                {props.address}
            </div>
            <div>
                {props.note}
            </div>
        </div>
    )
}

export default View